<mat-card appearance="outlined">
  <mat-card-header>
    <div class="card-title">
      <div class="card-header">
        <mat-card-title>
          <h1 class="pageTitle">{{ 'missions.title' | translate }}</h1>
        </mat-card-title>

        <form *ngIf="orders && !isLoadingFilterForm" [formGroup]="filterForm" (submit)="onFilter()" class="filterForm">
          <mat-form-field>
            <mat-label>Entrer une période</mat-label>
            <mat-date-range-input formGroupName="range" [rangePicker]="picker">
              <input matStartDate formControlName="fromStartDate" placeholder="Du" (focus)="picker.open()">
              <input matEndDate formControlName="toStartDate" placeholder="Au" (focus)="picker.open()">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>

          <button mat-icon-button type="submit" color="primary"
            [disabled]="filterForm.pristine || !filterForm.value.range.fromStartDate || !filterForm.value.range.toStartDate"
            matTooltip="Filtrer">
            <mat-icon>
              search
            </mat-icon>
          </button>

          <button mat-icon-button color="primary" matTooltip="Effacer les filtres" (click)="clearFilters()">
            <mat-icon>
              clear
            </mat-icon>
          </button>
        </form>
      </div>

      <section class="section-tracking" *ngIf="!isLoadingTimeTracking && !isLoadingVehicleStatus && !isClient">
        <fieldset class="time-tracking" *ngIf="!isLoadingTimeTracking && isAdmin">
          <legend>
            <b>Pointages en cours ({{usersLastTimeRecords.length}})</b>

            <ng-container *ngIf="usersLastTimeRecords.length > 0">
              <mat-icon
                (click)="timeTrackingPanelOpen ? closePanel('timeTrackingPanel') : openPanel('timeTrackingPanel')"
                #timeTrackingButton class="arrow-icon" color="primary">
                <ng-container *ngIf="timeTrackingPanelOpen">arrow_drop_up</ng-container>
                <ng-container *ngIf="!timeTrackingPanelOpen">arrow_drop_down</ng-container>
              </mat-icon>
            </ng-container>
          </legend>

          <div *ngIf="usersLastTimeRecords.length === 0">
            <p><i>Il n'y a actuellement aucun pointage en cours</i></p>
          </div>
          <div *ngIf="usersLastTimeRecords.length > 0">
            <ul class="list-drivers">
              <ng-container *ngFor="let user of usersLastTimeRecords; let i = index;">
                <li *ngIf="i < 4">{{user.username}}</li>
              </ng-container>
            </ul>
          </div>
          <div class="time-tracking-panel" #timeTrackingPanel id="timeTrackingPanel"
            *ngIf="usersLastTimeRecords.length > 0">
            <ul class="list-drivers">
              <li *ngFor="let user of usersLastTimeRecords">{{user.username}}</li>
            </ul>
          </div>
        </fieldset>

        <fieldset class="time-tracking" *ngIf="!isLoadingVehicleStatus">
          <legend>
            <b>Statuts des véhicules ({{vehicleStatus.length}})</b>
            <ng-container *ngIf="vehicleStatus.length > 0">
              <mat-icon #vehicleStatusButton class="arrow-icon"
                (click)="vehicleStatusPanelOpen ? closePanel('vehicleStatusPanel') : openPanel('vehicleStatusPanel')"
                color="primary">
                <ng-container *ngIf="vehicleStatusPanelOpen">arrow_drop_up</ng-container>
                <ng-container *ngIf="!vehicleStatusPanelOpen">arrow_drop_down</ng-container></mat-icon>
            </ng-container>
          </legend>
          <div *ngIf="vehicleStatus.length === 0">
            <p><i>Il n'y a actuellement aucun statuts de véhicules</i></p>
          </div>
          <div *ngIf="vehicleStatus.length > 0">
            <ul class="list-vehicles">
              <ng-container *ngFor="let vehicle of vehicleStatus; let i = index;">
                <li *ngIf="i < 2" class="vehicleStatus">
                  <mat-icon [ngClass]="vehicle.isAvailable ? 'green' : 'blue'">square</mat-icon> {{vehicle.username}}
                  {{vehicle.numberplate}}
                </li>
              </ng-container>
            </ul>
          </div>
          <div class="vehicle-status-panel" #vehicleStatusPanel id="vehicleStatusPanel"
            *ngIf="vehicleStatus.length > 0">
            <ul class="list-vehicles">
              <li *ngFor="let vehicle of vehicleStatus" class="vehicleStatus">
                <mat-icon [ngClass]="vehicle.isAvailable ? 'green' : 'blue'">square</mat-icon> {{vehicle.username}}
                {{vehicle.numberplate}}
              </li>
            </ul>
          </div>
        </fieldset>
      </section>

    </div>


  </mat-card-header>

  <mat-card-content>



    <section class="datatable-container">
      <section class="headerFilter">
        <div class="menuDisplayedColumns">
          <button mat-mini-fab color="primary" matTooltip="Préférences des colonnes" [matMenuTriggerFor]="menu">
            <mat-icon>list</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <div cdkDropList (cdkDropListDropped)="drop($event)">
              <div *ngFor="let displayedColumn of displayedColumnsMenuMissions" cdkDrag>
                <section class="menu-item" (click)="$event.stopPropagation()">
                  <ng-container *ngIf="displayedColumn.editable">
                    <mat-checkbox class="example-margin" [checked]="displayedColumn.selected"
                      (change)="onSelectMenu($event,displayedColumn.name)">
                      {{ 'orders.list.' + displayedColumn.name | translate }}
                    </mat-checkbox>
                  </ng-container>
                </section>
              </div>
            </div>
          </mat-menu>

          <button class="refreshButton" mat-raised-button color="primary" (click)="getList()">Rafraichir</button>

          <form [formGroup]="filterForm">
            <mat-checkbox formControlName="includeDeleted" (click)="onFilter()" color="primary">Afficher les
              commandes
              supprimées</mat-checkbox>
          </form>
        </div>

        <section class="actionsButtons">
          <app-select-orders-export-type class="actionButton" *ngIf="canExport" matTooltip="Exporter la sélection"
            [disabled]="isLoading || selection.selected.length === 0" title="orders.list.export"
            iconName="insert_drive_file" (onExportTypeSelected)="onExportSelection($event)">
          </app-select-orders-export-type>

          <app-select-orders-export-type class="actionButton" *ngIf="canExport"
            matTooltip="Exporter tout avec/sans filtre(s)" [disabled]="isLoading" title="orders.list.exportAll"
            iconName="insert_drive_file" (onExportTypeSelected)="onExportAll($event)">
          </app-select-orders-export-type>
        </section>
      </section>


      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChanged($event)"
        [formGroup]="filterForm">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="checkboxCell">
            <!-- <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox> -->
          </th>
          <td mat-cell *matCellDef="let row" class="checkboxCell">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="identifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.identifier' | translate}}
              <input class="identifier-filter" (click)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation(); filterEnter($event, 'identifier')" matInput type="number"
                formControlName="identifier" placeholder="Filtre">
            </div>
          </th>
          <td mat-cell *matCellDef="let order"> {{ order.identifier }} </td>
        </ng-container>

        <ng-container matColumnDef="transportVoucher">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.transportVoucher' | translate}}
              <input class="identifier-filter" (click)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation(); filterEnter($event, 'transportVoucher')" matInput type="text"
                formControlName="transportVoucher" placeholder="Filtre">
            </div>
          </th>
          <td mat-cell *matCellDef="let order"> {{ order?.transportVoucher }} </td>
        </ng-container>

        <ng-container matColumnDef="startDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'orders.list.startDate' | translate}}</th>
          <td mat-cell *matCellDef="let order">{{ order.startDate | amDateFormat: 'DD/MM/YYYY HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="urgency">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.urgency' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('urgency')" [list]="urgencies" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.urgency"> {{ order.urgency.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="sender">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.sender' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('sender')" [list]="senders" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.sender.address"> {{ order.sender?.address.name }} </span>
            <span *ngIf="!order.sender.address"> {{ order.sender.otherAddress }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="receivers">
          <th mat-header-cell *matHeaderCellDef>
            <div class="cellTh">
              {{ 'orders.list.receiver' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('receiver')" [list]="receivers" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.receivers.length > 1">
              <span *ngIf="order.receivers[order.receivers.length - 1].address"> {{
                order.receivers[order.receivers.length - 1].address.name }} (Multiples)</span>
              <span *ngIf="!order.receivers[order.receivers.length - 1].address"> {{
                order.receivers[order.receivers.length - 1].otherAddress }} (Multiples)</span>
            </span>
            <span *ngIf="order.receivers.length === 1">
              <span *ngIf="order.receivers[0].address"> {{ order.receivers[0].address.name }}</span>
              <span *ngIf="!order.receivers[0].address"> {{ order.receivers[0].otherAddress }}</span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="site">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Donneur d'ordre
              <div class="autocompleteFilter site-filter">
                <!-- <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('site')" [list]="sites" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter> -->
                <app-autocomplete *ngIf="!isLoadingFilterForm" [control]="filterForm.get('site')" [isFilter]="true"
                  [list]="sites" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation();"
                  (selectedOptionForFilter)="filterEnter($event, 'site')">
                </app-autocomplete>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.site"> {{ order.site?.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="lot">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Lot
              <div class="autocompleteFilter site-filter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('lot')" [list]="lots" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            {{ order.lot?.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="vehicleNumberplate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.vehicle' | translate}}
              <div class="autocompleteFilter site-filter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'numberplate'"
                  [control]="filterForm.get('vehicle')" [list]="vehicles" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.vehicle">
              {{ order.vehicle?.numberplate }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.status' | translate}}
              <mat-select class="status-filter" formControlName="status" (click)="$event.stopPropagation()"
                (selectionChange)="filterEnter($event, 'status')" placeholder="Filtre">
                <mat-option *ngFor="let status of allStatus" [value]="status.value">
                  {{status.name}}
                </mat-option>
              </mat-select>
            </div>
          </th>
          <td mat-cell *matCellDef="let order"> {{ showStatusText(order.status) | translate }} </td>
        </ng-container>

        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              {{ 'orders.list.client' | translate}}
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('client')" [list]="clients" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.client"> {{ order.client.name }} </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Créé par
              <div class="autocompleteFilter createdBy-filter">
                <app-autocomplete *ngIf="!isLoadingFilterForm" [control]="filterForm.get('createdBy')" [isFilter]="true"
                  [canString]="false" [list]="users" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation();"
                  (selectedOptionForFilter)="filterEnter($event, 'createdBy')">
                </app-autocomplete>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            <span *ngIf="order.createdBy">{{ order.createdBy?.username }} </span>
            <span *ngIf="!order.createdBy">Système </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Créé le </th>
          <td mat-cell *matCellDef="let order"> {{ order.createdOn | amDateFormat: 'DD/MM/YYYY HH:mm' }} </td>
        </ng-container>

        <ng-container matColumnDef="timeSpent">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Temps passé </th>
          <td mat-cell *matCellDef="let order"> {{ order.timeSpent | formatHours}} </td>
        </ng-container>


        <ng-container matColumnDef="driver">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="cellTh">
              Chauffeur
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm" [valueWanted]="'username'"
                  [control]="filterForm.get('driver')" [list]="drivers" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
          <td mat-cell *matCellDef="let order">{{ order.driver.username}}</td>
        </ng-container>

        <ng-container matColumnDef="progressReport">
          <th mat-header-cell *matHeaderCellDef>
            <div class="cellTh">
              État d’avancement
            </div>
          </th>
          <td mat-cell *matCellDef="let order">
            {{getProgressReport(order)}}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'orders.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let order" class="tdActions">
            <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
              [matTooltip]="'orders.list.detail' | translate" (click)="onSelectOrder(order.id)">
              <mat-icon aria-label="Edit">zoom_in</mat-icon>
            </button>

            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu boutons" color="primary"
              *ngIf="!order.isDeleted">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item *ngIf="isDispatcher && order.status === 1"
                (click)="changeStatus('receivedByDispatcher', order)">
                <mat-icon color="primary">call_received</mat-icon>
                <span>{{'orders.list.receivedByDispatcher' | translate}}</span>
              </button>
              <button mat-menu-item *ngIf="isDispatcher && order.status === 2"
                (click)="changeStatus('cancelled', order)">
                <mat-icon color="primary">clear</mat-icon>
                <span>{{'orders.list.cancelled' | translate}}</span>
              </button>
              <button mat-menu-item *ngIf="isDispatcher && (order.status === 1 || order.status === 2) && !order.driver"
                (click)="onSelectOrder(order.id)">
                <mat-icon color="primary">drive_eta</mat-icon>
                <span>{{'orders.list.assignDriver' | translate}}</span>
              </button>
              <button mat-menu-item *ngIf="isDispatcher && order.status === 8"
                (click)="changeStatus('finished', order)">
                <mat-icon color="primary">block</mat-icon>
                <span>{{'orders.list.finished' | translate}}</span>
              </button>
              <button mat-menu-item *ngIf="isAdmin && order.status === 128" (click)="changeStatus('finished', order)">
                <mat-icon color="primary">flag</mat-icon>
                <span>{{'orders.list.finished' | translate}}</span>
              </button>
              <button mat-menu-item *ngIf="!order.isDeleted && isDispatcher" (click)="changeTimeSpent(order)">
                <mat-icon color="primary">access_time</mat-icon>
                <span>{{'orders.list.changeTimeSpent' | translate}}</span>
              </button>

              <button mat-menu-item class="action-button" color="primary" [disabled]="isLoading"
                (click)="openInMworker(order)" *ngIf="displayMworkerButton(order)"
                matTooltip="Vous devez être connecté à mWorker">
                <mat-icon aria-label="Edit" color="primary">map</mat-icon>
                <span>
                  {{ 'orders.list.goMap' | translate }}
                </span>
              </button>

              <button mat-menu-item *ngIf="isAdmin" (click)="delete(order)">
                <mat-icon color="primary">delete</mat-icon>
                <span>{{'orders.list.delete' | translate}}</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let mission; columns: displayedColumns;" class="mission" [ngClass]="{
          'disabled': mission.status === 32 || mission.isDeleted,
          'isTreated' : mission.status === 4,
          'inProgress' : mission.status === 128,
          'finished' : mission.status === 16
      }"></tr>
      </table>
    </section>
    <mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
    <mat-paginator *ngIf="pagination" [pageSize]="pagination.pageSize" [length]="pagination.totalRecords"
      [pageIndex]="pagination.pageNumber - 1" (page)="onPageChanged($event)" showFirstLastButtons></mat-paginator>
  </mat-card-content>
</mat-card>
